$(function(){

    // scroll-behavior: smooth が使えるかを CSS.supports または css の適用から判断
    var canBehaveSmooth = (window.CSS && window.CSS.supports) ? window.CSS.supports('scroll-behavior: smooth') : ($('html').css('scroll-behavior') === 'smooth');

    // ページトップに戻る
    if (!canBehaveSmooth) {
    	$('.scroll').click(function(){
    		var speed = 800;
    		var href = $(this).attr("href");
    		var target = $(href === "#" || href === "" ? 'html' : href);
    		var position = target.offset().top;
    		$("html, body").animate({scrollTop:position}, speed, "swing");
    		return false;
    	});
    }

   // object-fit
   var canFitPosition = (window.CSS && window.CSS.supports) ? window.CSS.supports('object-position: center') : (document.documentElement.style.objectPosition !== void 0);
   if (!canFitPosition) {
       $('img.fit-cover').each(function(idx, elm) {
           var parent = elm.parentElement;
           parent.style.cssText =
           'background-size: cover;' +
           'background-position: center;' +
           'background-repeat: no-repeat;' +
           'background-image: url('+elm.src+');';
           parent.removeChild(elm);
       });
       $('img.fit-contain').each(function(idx, elm) {
           var parent = elm.parentElement;
           parent.style.cssText =
           'background-size: contain;' +
           'background-position: center;' +
           'background-repeat: no-repeat;' +
           'background-image: url('+elm.src+');';
           parent.removeChild(elm);
       });
   }

   //スマホメニュー
   $('.fixed_header').on('click','.btn_menu_open',function(){
        $('.search_box').removeClass('active');
        var $targetMenu = $($(this).attr('href'));
        $targetMenu.addClass('active');
        $('html').addClass('menu_open');
        return false;
    });
    $('.menu_wrap').on('click','.btn_menu_close',function(){
        $('.search_box').removeClass('active');
        $('html').removeClass('menu_open');
        return false;
    });

    //エージェントに問い合わせ
    var content = $('.side .duplicate').html();
    $('#wrapper').after(content);

    $('.open_agent').on('click','.btn_agent_open',function(){
        if($('.side_content').hasClass('active')){
            $('.side_content').removeClass('active');
            $('html').removeClass('menu_open');
        }else{
            $('.side_content').addClass('active');
            $('html').addClass('menu_open');
        }
        return false;
    });

    $('.side_content').on('click','.btn_agent_close',function(){
        $('.side_content').removeClass('active');
        $('html').removeClass('menu_open');
        return false;
    });

    //TOP collection スライダー
    $('.collection_slider').slick({
        autoplay:true, //自動で画像を切り替える
        autoplaySpeed:4000, //自動で画像が切り替えられるまでの時間 1000 = 1秒
        speed:1000,
        fade:false,
        arrows:true,
        adaptiveHeight:false,
        dots:false,
        slidesToShow:3,
        respondTo: 'window',
        responsive: [
            {
                breakpoint: 960,     // 600〜1023px
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    centerMode: true,
                    infinite: true,
                    dots: true
                }
            },{
                breakpoint: 878,     // 600〜1023px
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    centerMode: true,
                    infinite: true,
                    dots: true
                }
            }
        ]
    });

    //TOP agent スライダー
    $('.agent_slider').slick({
        autoplay:false, //自動で画像を切り替える
        autoplaySpeed:4000, //自動で画像が切り替えられるまでの時間 1000 = 1秒
        speed:1000,
        fade:false,
        arrows:true,
        adaptiveHeight:false,
        dots:false,
        slidesToShow:2,
        respondTo: 'window',
        responsive: [
            {
                breakpoint: 878,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    centerMode: true,
                    infinite: true,
                    dots: true
                },
            },{
                breakpoint: 660,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    centerMode: true,
                    infinite: true,
                    dots: true
                },
            },{
                breakpoint: 470,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    centerMode: true,
                    infinite: true,
                    dots: true
                },
            }
        ]
    });

    //fixed_header
    $(window).on('scroll load',function (){
        $('.fixed_header').each(function(){

            var scroll = $(window).scrollTop();
            //var windowHeight = $(window).height();
            if( $('#page_top .sec_visual').length ){
                var psition = $('.sec_visual').outerHeight() + 100;
            }else if( $('#header').length ){
                var psition = $('#header').outerHeight() + 100;
            }else{
                var psition = 300;
            }

            if(scroll >= psition ){
                $('.fixed_header').addClass('active');
            }else{
                $('.fixed_header').removeClass('active');
            }
        });
    });

    //
    $(function(){
        $('.sp_slider').each(function(){
            if($(window).width() <= 878){
                $('.property_list').slick({
                    respondTo: 'window',
                    responsive: [
                        {
                        breakpoint: 878,     // 600〜1023px
                        settings: {
                            autoplay:false, //自動で画像を切り替える
                            autoplaySpeed:4000, //自動で画像が切り替えられるまでの時間 1000 = 1秒
                            speed:1000,
                            fade:false,
                            arrows:true,
                            adaptiveHeight:false,
                            dots:false,
                            respondTo: 'window',

                            slidesToShow: 1,
                            slidesToScroll: 1,
                            centerMode: true,
                            infinite: true,
                            dots: true
                        }
                    }]
                });
            }
        })
    });

    //totop
    $(window).on('scroll load',function (){
        $('.totop').each(function(){
            var psition = $('.totop').offset().top + $('.totop').outerHeight();
            var scroll = $(window).scrollTop();
            var windowHeight = $(window).height();

            if(scroll >= 300 ){
                $('.totop a').addClass('show');
            }else{
                $('.totop a').removeClass('show');
            }

            if(scroll >= psition -windowHeight ){
                $('.totop a').addClass('bottom');
                }else{
                $('.totop a').removeClass('bottom');
            }
        });
    });

    //アニメーション
    $(document).ready(function(){
        animation();
    });
    $(document).on('scroll',function (){
       animation();
    });
    function animation(){
        scroll = $(window).scrollTop();
        windowHeight = $(window).height();
        $(".effect").each(function(){
            var $this = $(this);
            var imgPos = $this.offset().top;
            if (scroll > imgPos - windowHeight + windowHeight/4){
                if($this.hasClass('late')){
                    setTimeout(function(){
                        $this.addClass('move');
                    },200);
                }else{
                    $this.addClass('move');
                }
            }
        });
    }

    //fancybox
    $('.fancybox').fancybox({
        margin:[50,15,50,15],
    });

    //アカウントボタン
    $('.loginbox').on('click','.next',function(){
        $('html').addClass('fancybox-lock');
        return false;
    });

    //物件 スライダー
    $('.property_slider').slick({
        autoplay:false, //自動で画像を切り替える
        autoplaySpeed:4000, //自動で画像が切り替えられるまでの時間 1000 = 1秒
        speed:1000,
        fade:false,
        arrows:false,
        adaptiveHeight:false,
        dots:false,
        slidesToShow:1,
        adaptiveHeight:true,
        lazyLoad:true,
        infinite: true,
        asNavFor: '.property_slider_nav',
    });

    $('.property_slider_nav').slick({
        accessibility: true,
        autoplay: false,
        autoplaySpeed: 4000,
        speed: 400,
        arrows: true,
        infinite: true,
        slidesToShow: 5,
        slidesToScroll: 1,
        asNavFor: '.property_slider',
        focusOnSelect: true,
        centerMode: true,
        //vertical: true,
        lazyLoad:true,
        respondTo: 'window',
        responsive: [
          {
            breakpoint: 878,
            settings: {
              slidesToShow: 3,
            }
          }]
    });

    //物件詳細ページ エージェントにお問い合わせ
    $('.contact_wrap .btn_wrap').on('click','a',function(){
        var $parent = $(this).parents('.contact_wrap');
        var $outer = $parent.find('.form_wrap');
        var $inner = $outer.find('.form_inner');
        var innerHeight = $inner.outerHeight();

        if($parent.hasClass('active')){
            $parent.removeClass('active');
            $outer.height(0);
        }else{
            $parent.addClass('active');
            $outer.height(innerHeight);
        }
        return false;
    });
});
